import React from 'react';
import { BaseIcon } from '../../base/BaseIcon';
import { IconProps } from '../../types';

export const TsplatShowPnrIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M8.57 14.81H7.56C7.21759 14.81 6.94 15.0876 6.94 15.43V16.44C6.94 16.7824 7.21759 17.06 7.56 17.06H8.57C8.91242 17.06 9.19 16.7824 9.19 16.44V15.43C9.19 15.0876 8.91242 14.81 8.57 14.81Z"
        fill={color}
      />
      <path
        d="M12.51 10.88H11.5C11.1576 10.88 10.88 11.1576 10.88 11.5V12.51C10.88 12.8524 11.1576 13.13 11.5 13.13H12.51C12.8524 13.13 13.13 12.8524 13.13 12.51V11.5C13.13 11.1576 12.8524 10.88 12.51 10.88Z"
        fill={color}
      />
      <path
        d="M16.44 6.94H15.43C15.0876 6.94 14.81 7.21759 14.81 7.56V8.57C14.81 8.91242 15.0876 9.19 15.43 9.19H16.44C16.7824 9.19 17.06 8.91242 17.06 8.57V7.56C17.06 7.21759 16.7824 6.94 16.44 6.94Z"
        fill={color}
      />
      <path
        d="M21.9 2.10001C18.33 -1.46999 11.19 0.0900054 5.64001 5.64001C0.0900054 11.19 -1.46999 18.33 2.10001 21.9C3.39001 23.19 5.16001 23.82 7.15001 23.82C10.64 23.82 14.83 21.91 18.36 18.37C23.91 12.82 25.46 5.67001 21.9 2.11001V2.10001ZM16.95 16.95C12.35 21.55 6.20001 23.17 3.51001 20.49C0.830005 17.81 2.45001 11.65 7.05001 7.05001C10.14 3.96001 13.93 2.22001 16.9 2.22001C18.35 2.22001 19.61 2.64001 20.49 3.52001C23.17 6.20001 21.55 12.36 16.95 16.96V16.95Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

TsplatShowPnrIcon.displayName = 'TsplatShowPnrIcon';
